<template>
  <div>
    <breadcrumbs  :adventure="adventure" :adventureId="adventureId" :chapter="chapter" :chapterId="chapterId" :objectId="selectedObjectId" :object="selectedObject"></breadcrumbs>
    <section id="page-objects" class="mdl-grid adv-content" style="background-color: white; margin-top:20px;">
      <div class="mdl-grid mdl-cell--12-col">
        <div class="mdl-cell--4-col mdl-cell--12-col-tablet" >
          <table id="adv-table" class="mdl-data-table mdl-js-data-table mdl-shadow--2dp mdl-cell--12-col">
            <thead>
              <tr>
                <th class="mdl-data-table__cell--non-numeric"><i class="material-icons">widgets</i> Objects</th>
                <th class="mdl-data-table__cell--non-numeric"><button @click="createObject" class="mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect" style="position: absolute; top: 6px; right: 5px;">New Object</button></th>
              </tr>
            </thead>
            <tbody v-sortable >
              <tr v-for="(object, objectKey) in chapter.objects" :name="objectKey" :class="selectionClass(objectKey)" @click="selectObject(objectKey)">
                <td class="mdl-data-table__cell--non-numeric">{{object.name}}</td>
                <td class="mdl-data-table__cell--non-numeric" style="text-align: right"><button :objectKey="objectKey" @click="deleteObject" class="mdl-button mdl-js-button mdl-js-ripple-effect" >
                <i :objectKey="objectKey" class="material-icons" >delete</i></button></td>
              </tr>
            </tbody>
            <tfoot style="margin: 0; padding: 0;">
              <td style="text-align: left; margin: 0; padding: 0; width:100%; height:60px;" colspan="2">
                <dropzone-firebase-multiple v-if="user" style="width:100%; height:100%" :folder="user.uid+'/'+adventureId+'/'+chapterId+'/objects'" :el-ref="objectsRef" ></dropzone-firebase-multiple>
              </td>
            </tfoot>
          </table>
        </div>
        <div class="mdl-cell--8-col mdl-cell--12-col-tablet" >
          <div v-if="selectedObjectId" style="background-color: white; padding-left: 30px; text-align: left;">
           <h5 class="mdl-cell--12-col">Edit Object</h5>
            <div :class="{'is-dirty': selectedObject.name}" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col">
              <input class="mdl-textfield__input" type="text" id="sample1" :value="selectedObject.name" @input='updateName'>
              <label class="mdl-textfield__label" for="sample1">Name...</label>
            </div>
            <div class="mdl-cell--12-col">
              <dropzone-firebase dropzone-firebase v-if="user" :file-name="selectedObjectId" :folder='user.uid+"/"+adventureId+"/"+chapterId+"/objects/"' :bg-image='selectedObject.bg' @upload='objectBgUpdate'></dropzone-firebase>
            </div>         
          </div>
        </div>        
      </div>
    </section>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable'
  import Breadcrumbs from './Breadcrumbs.vue'
  import DropzoneFirebase from './DropzoneFirebase.vue'
  import DropzoneFirebaseMultiple from './DropzoneFirebaseMultiple.vue'

  Vue.use(Sortable)
  var sectionObjectEdit

  export default{
    components: {
      Breadcrumbs,
      DropzoneFirebase,
      DropzoneFirebaseMultiple
    },
    data: ()=>({
      adventure: {
        name: "", 
        description: "",
        chapters: {}},
      adventureId: "",
      chapterId: "",
      chapter: {
        name: "", 
        description: ""},
      object: {bg: ""},
      selectedObjectId: "",
      selectedObject: "",
      advRef: {},
      user: null,
      objectsRef: {}
    }),
    computed: {
      
    },
    created() {
      sectionObjectEdit = this;
      this.adventureId = this.$route.params.adventure;
      this.chapterId = this.$route.params.chapter;
      this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
      this.objectsRef = window.firebase.database().ref('adventures/'+this.adventureId+'/chapters/'+this.chapterId+'/objects');
      this.advRef.on('value', function(snapshot) {
        sectionObjectEdit.adventure = snapshot.val();
        sectionObjectEdit.chapter = sectionObjectEdit.adventure.chapters[sectionObjectEdit.chapterId];
        if(sectionObjectEdit.chapter.objects && Object.keys(sectionObjectEdit.chapter.objects)[0]){
        if(!sectionObjectEdit.selectedObjectId || sectionObjectEdit.selectedObjectId===""){
            sectionObjectEdit.selectedObjectId = Object.keys(sectionObjectEdit.chapter.objects)[0];          
        }
        sectionObjectEdit.selectedObject = sectionObjectEdit.chapter.objects[sectionObjectEdit.selectedObjectId];
        }
      });
      this.user = window.firebase.auth().currentUser;
      window.firebase.auth().onAuthStateChanged((user) => {
        sectionObjectEdit.user = user;
      });
    },
    firebase: {
    },
    methods: {
      selectionClass(objectId){
        return objectId === this.selectedObjectId ? "selected" : ""
      },
      selectObject(objectId){
        this.selectedObjectId = objectId;
        this.selectedObject = this.chapter.objects[this.selectedObjectId];
      },
       updateName(e) {
        this.advRef.child('chapters').child(this.chapterId).child('objects').child(this.selectedObjectId).child('name').set(event.target.value)
      },
      createObject(e){
        var newObject = this.advRef.child('chapters').child(this.chapterId).child('objects').push({name: "Untitled Object", bg: ""});
        this.selectObject(newObject.key);
      },
      deleteObject(e){
        e.stopPropagation();
        var thisObjId = e.target.attributes['objectKey'].value;
        window.firebase.storage().ref(this.user.uid+"/"+this.adventureId+"/"+this.chapterId+"/objects/"+thisObjId+".png").delete();
        if(thisObjId===this.selectedObjectId){this.selectedObjectId = this.selectedObject = null;}
        this.advRef.child('chapters').child(this.chapterId).child('objects').child(thisObjId).remove();
        var data = {message: 'Object deleted succesfully' };
        document.querySelector('#snackbar').MaterialSnackbar.showSnackbar(data);
      },
      objectBgUpdate(value){
        this.advRef.child('chapters').child(this.chapterId).child('objects').child(this.selectedObjectId).child('bg').set(value);
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// SectionObjects.vue?08f0a104